module.exports = __webpack_public_path__ + "static/ronda-80ebafe9902b8f1991c88fc55d55a338.jpg";